module.exports = __webpack_public_path__ + "static/media/day23.workshop.6ccbb90b.md";